import React from 'react';
import { ContextualMenu } from '@fluentui/react';

const InlineMenu = (props) => {
    return (
        <div>
            {props.showMenu && (
                <ContextualMenu
                    setInitialFocus
                    onDismiss={props.closeMenu}
                    items={props.items}
                    shouldFocusOnMount={true}
                    target={props.target}
                ></ContextualMenu>
            )}
        </div>
    );
};

export default InlineMenu;
